export default function ExpertReview() {
  return (
    <section className="bg-background-50 py-20 md:py-28 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          {/* Left - Content */}
          <div className="flex-1 lg:w-3/5">
            <div className="flex items-center gap-3 mb-8">
              <span className="w-2 h-2 rounded-full bg-foreground-950"></span>
              <span className="text-foreground-600 text-sm font-medium font-sans uppercase tracking-wide whitespace-nowrap">
                Экспертный обзор
              </span>
            </div>

            <blockquote className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-950 leading-relaxed mb-8 max-w-xl">
              <span className="text-primary-400 text-5xl md:text-6xl leading-none font-heading">&ldquo;</span>
              <br />
              YOYBUY Spreadsheet —
              <br />
              это самый удобный
              <br />
              инструмент для заказа
              <br />
              товаров из Китая,
              <br />
              который я когда-либо
              <br />
              использовал.
            </blockquote>

            <div className="flex items-center gap-3">
              <div>
                <p className="text-foreground-950 font-semibold text-sm font-sans">
                  YOYBUY Expert
                </p>
                <div className="flex items-center gap-1 mt-1">
                  <i className="ri-star-fill text-accent-500 text-xs w-3 h-3 flex items-center justify-center"></i>
                  <i className="ri-star-fill text-accent-500 text-xs w-3 h-3 flex items-center justify-center"></i>
                  <i className="ri-star-fill text-accent-500 text-xs w-3 h-3 flex items-center justify-center"></i>
                  <i className="ri-star-fill text-accent-500 text-xs w-3 h-3 flex items-center justify-center"></i>
                  <i className="ri-star-fill text-accent-500 text-xs w-3 h-3 flex items-center justify-center"></i>
                  <span className="text-foreground-400 text-xs ml-1 font-sans">Проверено</span>
                </div>
              </div>
            </div>

            <a
              href="/"
              className="inline-flex items-center gap-2 mt-8 text-foreground-500 hover:text-foreground-800 text-sm font-medium font-sans no-underline transition-colors whitespace-nowrap"
            >
              <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
              На главную YOYBUY Spreadsheet
            </a>
          </div>

          {/* Right - Image */}
          <div className="flex-1 lg:w-2/5 flex justify-center">
            <div className="w-64 h-80 md:w-80 md:h-[420px] rounded-3xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Soft%20editorial%20portrait%20of%20confident%20professional%20in%20cream%20linen%20blazer%20against%20warm%20beige%20background%2C%20clean%20minimalist%20composition%2C%20warm%20natural%20tones%2C%20modern%20Scandinavian%20aesthetic%2C%20soft%20diffused%20lighting%20from%20window%2C%20professional%20yet%20approachable%20mood%2C%20high%20end%20fashion%20editorial%20style%2C%20elegant%20simple%20portrait%2C%20no%20text&width=800&height=1000&seq=yoybuy-expert-v2-img&orientation=portrait"
                alt="Эксперт YOYBUY"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}